const WORKOUT_SECTIONS_ANALYTICS_EVENT = {
  CONVERTED_TO_CIRCUIT: 'Workout Section Converted To Circuit',
  CONVERTED_TO_STANDARD_SECTION: 'Workout Section Converted To Standard Section',
  CREATED: 'Workout Section Created',
  COPIED: 'Workout Section Copied',
  DELETED: 'Workout Section Deleted'
}

export default WORKOUT_SECTIONS_ANALYTICS_EVENT
